// Escapes LIKE/ILIKE metacharacters so a value is matched literally rather than
// as a wildcard pattern. We use ILIKE for case-insensitive lookups (SCIM `eq`
// filters, email lookups) that are semantically exact matches, so an unescaped
// `_` or `%` in the input (common in group names and email local parts) must
// not turn into a wildcard. Backslash is Postgres ILIKE's default escape char.
export function escapeLikePattern(value: string): string {
  return value.replace(/[\\%_]/g, "\\$&");
}
